/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AuditReportInterfaceDto } from '../../models/audit-report-interface-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface CreateOrUpdateAuditReport$Params {
  body: AuditReportInterfaceDto;
}

export function createOrUpdateAuditReport(
  http: HttpClient,
  rootUrl: string,
  params: CreateOrUpdateAuditReport$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<AuditReportInterfaceDto>> {
  const rb = new RequestBuilder(rootUrl, createOrUpdateAuditReport.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuditReportInterfaceDto>;
    }),
  );
}

createOrUpdateAuditReport.PATH = '/service/v1/afterSales';
